import { render, staticRenderFns } from "./TeamBuilder.vue?vue&type=template&id=3c84e8c1&scoped=true&"
import script from "./TeamBuilder.vue?vue&type=script&lang=js&"
export * from "./TeamBuilder.vue?vue&type=script&lang=js&"
import style0 from "./TeamBuilder.vue?vue&type=style&index=0&id=3c84e8c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c84e8c1",
  null
  
)

export default component.exports